import type { RGBColor } from 'react-color';

function colorStringToObj(str = ''): Required<RGBColor> {
  const [r = 0, g = 0, b = 0, a = 1] = str.split(',').map(Number);
  return { r, g, b, a };
}

export default colorStringToObj;
